import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { catchError, firstValueFrom, of, Subject, takeUntil } from 'rxjs';
import { UserService } from '../../../core/user/user.service';
import { FileUploader } from '../../../core/components/file-uploader/file-uploader';
import { HttpService } from '../../../core/http/http.service';
import { CompanyUser } from '../../../core/user/companyUser.model';

@Component({
    selector: 'user-avatar',
    templateUrl: './user-avatar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserAvatarComponent extends FileUploader implements OnInit, OnDestroy {

    @Input() profileImage: string;

    base64: string;
    imageUrl: string;

    dragOverCounter = 0;
    isDragOver = false;
    loading = false;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private http: HttpService,
        private userService: UserService,
    ) {
        super();
    }

    ngOnInit(): void {
        this.userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: CompanyUser) => {
                this.imageUrl = user.profileImage.startsWith('http') ? `${user.profileImage}&timestamp=${new Date().getTime()}`
                    : `${this.http.getBaseUrl()}${user.profileImage}&timestamp=${new Date().getTime()}`;
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // TODO no dejar subir ficheros que no sean imagenes
    uploadFile(file: File) {
        this.loading = true;

        const reader = new FileReader();
        reader.onload = async (e) => {
            const base64 = String((e.target as FileReader).result);
            try {
                const user = await firstValueFrom(this.userService.get());
                user.profileImage = base64;
                await firstValueFrom(this.userService.update(user).pipe(
                    catchError((error) => {
                        console.error(error);
                        return of(error);
                    })));
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        };

        reader.onerror = (e) => {
            this.loading = false;
        };

        reader.readAsDataURL(file);

    }
}
